/**
 * RenewIdToken
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { renewIdToken } from '../../../../services/auth/actions';

export class RenewIdToken extends React.PureComponent {
    componentDidMount() {
        this.props.renewIdToken();

        this.timer = setInterval(() => {
            this.props.renewIdToken();
        }, this.props.interval);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        return null;
    }
}

RenewIdToken.propTypes = {
    renewIdToken: PropTypes.func.isRequired,
    interval: PropTypes.number
};

RenewIdToken.defaultProps = {
    interval: 3600000
};

export default connect(
    null,
    { renewIdToken }
)(RenewIdToken);
